import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../../app/services/user.service';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addbank',
    templateUrl: './addbank.component.html',
    styleUrls: ['./addbank.component.css']
})
export class AddBankDialog {
    element: any = {};
    myForm: any = FormControl;
    constructor(
        public dialogRef: MatDialogRef<AddBankDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public userService: UserService,
    ) {
        this.element = data;
        this.myForm = this.fb.group({
            firstName: ['', [Validators.required]],
            lastName: ['', [Validators.required]],
            middleName: [''],
            mobileNumber: ['', [Validators.required]],
            panNo: ['', [Validators.required]],
            ifscCode: ['', [Validators.required]],
            remitterAccountNumber: ['', [Validators.required]],
        });
    }

    // Save Form to database
    saveBank() {
        const { notif } = defaults
        if (this.element) {

            this.userService.csrf().subscribe(success => {
                this.myForm.value._csrf = success['_csrf'];
                this.myForm.value.userid = this.element.userid;
                this.userService.saveUserBank(this.myForm.value).subscribe(response => {
                    if (response.status) {
                        this.notifSer.success('Success', response.message, notif)
                        // Emit the form data when closing the dialog
                        this.dialogRef.close();
                    } else this.notifSer.error('Error', response.message, notif);
                }, err => this.notifSer.error('Error', err.error.message, notif));
            })

        }
    }

}


// WEBPACK FOOTER //
// ./src/app/bank/addbank/addbank.component.ts